import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const ADVANCED_RAW_RULE_EDITOR_CLASS_NAME = 'AdvancedRawRuleEditor';
export const ADVANCED_RAW_RULE_EDITOR_CLASS_SLOTS = ['root'] as const;

export type AdvancedRawRuleEditorClassSlot =
	(typeof ADVANCED_RAW_RULE_EDITOR_CLASS_SLOTS)[number];

export interface AdvancedRawRuleEditorClasses {
	root: string;
}

export type AdvancedRawRuleEditorClassKey = keyof AdvancedRawRuleEditorClasses;

export const getAdvancedRawRuleEditorUtilityClass = (slot: string) =>
	generateUtilityClass(ADVANCED_RAW_RULE_EDITOR_CLASS_NAME, slot);

export const advancedRawRuleEditorClasses: AdvancedRawRuleEditorClasses =
	generateUtilityClasses(ADVANCED_RAW_RULE_EDITOR_CLASS_NAME, ['root']);

export default advancedRawRuleEditorClasses;
